import { createContext, useContext } from 'react';

export const OrgContext = createContext(null);
export const useOrgId = () => useContext(OrgContext);
